import '.n{position:relative;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.id{resize:none;}.ssr-plugin'
import '.gh{padding:6px 10px;}.ssr-plugin'
import '.fk{outline:none;}.ssr-plugin'
import '.a8{background:transparent;}.ssr-plugin'
import '.p{position:absolute;}.ssr-plugin'
import '.dr{right:0px;}.ssr-plugin'
import '.ie{transform:translateY(100%);}.ssr-plugin'
import { useRef, useState, Ref } from 'react'
import { colors } from '../../tokens/colors.js'
import { radius } from '../../utils/radius.js'
import { Badge } from '../Badge/index.js'
import { styled, Style } from 'inlines'
import { useTextDirection } from '../../hooks/useTextDirection.js'
import { shadows } from '../../utils/shadows.js'
import { TEXT_VARIANT_STYLES } from '../../tokens/typography.js'
import { LabelDescription } from '../LabelDescription/index.js'

type TextAreaInputProps = {
  variant?: 'border' | 'ghost'
  value?: string
  onChange: (value: string) => void
  placeholder?: string
  error?: boolean
  maxLength?: number
  rows?: 'adaptive' | number
  disabled?: boolean
  autoFocus?: boolean
  onFocus?: (e: React.FocusEvent<HTMLTextAreaElement>) => void
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void
  style?: Style
  onScroll?: (e: React.UIEvent<HTMLTextAreaElement>) => void
  ref?: Ref<any>
  label?: string
  description?: string
  errorMessage?: string
}

const TextAreaInput = ({
  variant = 'border',
  value,
  onChange,
  rows = 'adaptive',
  error,
  maxLength,
  placeholder,
  disabled,
  autoFocus,
  onFocus,
  onBlur,
  onScroll,
  label,
  description,
  errorMessage,
  style,
  ref,
}: TextAreaInputProps) => {
  const [focus, setFocus] = useState(false)
  const length = typeof value !== 'string' ? 0 : value.length
  const direction = useTextDirection(value)

  return (
    <LabelDescription
      label={label}
      description={description}
      error={error && errorMessage}
    >
      <div className="n a h"
      >
        <styled.textarea className="id gh fk h a8"
          ref={ref}
          value={value ?? ''}
          onChange={(e) => {
            onChange(e.target.value)
          }}
          onFocus={(e) => {
            setFocus(true)
            onFocus?.(e)
          }}
          onBlur={(e) => {
            setFocus(false)
            onBlur?.(e)
          }}
          onScroll={onScroll}
          autoFocus={autoFocus}
          placeholder={placeholder}
          disabled={disabled}
          maxLength={maxLength}
          dir={direction}
          style={{
            color: length === 0 ? colors.neutral60 : colors.neutral100,
            borderRadius: radius[12],
            ...(rows === 'adaptive' && {
              fieldSizing: 'content',
              minHeight: 68,
              maxHeight: 256,
            }),
            border: `1px solid ${colors.neutral20Adjusted}`,
            ...(focus &&
              variant !== 'ghost' &&
              !disabled && {
                background: colors.neutralInverted100,
                border: `1px solid ${colors.neutral100}`,
                outline: `4px solid ${colors.neutral20}`,
              }),
            ...(error && {
              border: `1px solid ${colors.red80}`,
              ...(focus &&
                !disabled && {
                  background: colors.neutralInverted100,
                  border: `1px solid ${colors.red100}`,
                  outline: `4px solid ${colors.red60}`,
                }),
            }),
            ...(disabled && {
              color: disabled ? colors.neutral20 : colors.neutral60,
              background: colors.neutral5,
              border: `1px solid transparent`,
            }),
            ...TEXT_VARIANT_STYLES['display-regular'],
            '&::placeholder': {
              userSelect: 'none',
              color: disabled ? colors.neutral20 : colors.neutral60,
            },
            // color:'blue',
            ...style,
          }}
          rows={rows === 'adaptive' ? undefined : rows}
        />
        {focus && maxLength && (
          <div className="p dr ie a"
            style={{
              bottom: -4,}}
          >
            <Badge
              color={error ? 'red-fill' : 'neutral-fill'}
              style={{
                boxShadow: shadows.popoverSmall,
              }}
            >{`${length}/${maxLength}`}</Badge>
          </div>
        )}
      </div>
    </LabelDescription>
  )
}

export type { TextAreaInputProps }
export { TextAreaInput }
